import { createAsyncThunk } from "@reduxjs/toolkit"
import { AppThunkAPIType } from "../../app/appTypes"
import { getWithAuth, postWithAuth } from "../../http"

export type AccessRequestStatus = "Pending" | "Approved" | "Rejected"

export interface PubAccessRequest {
    requestId: string
    email: string
    requestedAt: string
    status: AccessRequestStatus
    decisionAt: string | null
    decisionByUser: string | null
}

export const loadAccessRequests = createAsyncThunk<PubAccessRequest[], { objectType: string, objectId: string }, AppThunkAPIType>("public-access-request/load", async (arg, { dispatch, rejectWithValue }) => {
    const { objectType, objectId } = arg
    const result = await dispatch(getWithAuth({
        url: `api/public-access/requests/${objectType}/${objectId}?includeHistory=true`,
    }))
    const { payload } = result
    if (getWithAuth.fulfilled.match(result)) {
        return payload as PubAccessRequest[]
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export interface AccessStatusPayload {
    requestId: string
    approve: boolean
}

export const setStatusOfAccessRequest = createAsyncThunk<AccessStatusPayload, AccessStatusPayload, AppThunkAPIType>("public-access-request/set-status", async (arg, { dispatch, rejectWithValue }) => {
    const result = await dispatch(postWithAuth({
        url: `api/public-access/requests/decision`,
        payload: arg,
    }))
    const { payload } = result
    if (postWithAuth.fulfilled.match(result)) {
        return arg
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export interface GeneratePayload {
    objectType: string
    objectId: string
    expiresAt: string | null
    maxUses: number | null
    accessLevel: string
}
export interface GenerateResult { token: string }
export const generatePublicToken = createAsyncThunk<GenerateResult, GeneratePayload, AppThunkAPIType>("public-access-request/generate-token", async (arg, { dispatch, rejectWithValue }) => {
    const result = await dispatch(postWithAuth({
        url: `api/public-access/token/generate`,
        payload: arg,
    }))
    const { payload } = result
    if (postWithAuth.fulfilled.match(result)) {
        return payload as GenerateResult
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})
